import React from "react";
import img1 from "../1.png";
import img2 from "../2.png";
import img3 from "../3.png";
import img4 from "../4.png";

const Dashboard = () => {
  return (
    <div
      style={{
        border: ".9px solid #D6D6D6",
        display: "flex",
        borderRadius: "6px",
        marginBottom: "15px",
      }}
    >
      <div
        style={{
          width: "25%",
          border: "none",
          borderRadius: "6px 0px 0px 6px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "20px",
          gap: "20px",
          borderRight: ".6px solid  #D6D6D6",
        }}
      >
        <img src={img4} style={{ height: "47px", width: "47px" }}></img>
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <p
            className="mb-0"
            style={{
              fontSize: "20px ",
              fontWeight: "700 ",
              color: "#3B3A3A ",
            }}
          >
            390M
          </p>
          <p
            className="mb-0"
            style={{ fontSize: "14px", fontWeight: "500", color: "#75738C" }}
          >
            MRF Record Count
          </p>
        </div>
      </div>
      <div
        style={{
          width: "25%",
          border: "none",
          borderRadius: "6px 0px 0px 6px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "20px",
          gap: "20px",
          borderRight: ".6px solid  #D6D6D6",
        }}
      >
        <img src={img1} style={{ height: "47px", width: "47px" }}></img>
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <p
            className="mb-0"
            style={{
              fontSize: "20px ",
              fontWeight: "700 ",
              color: "#3B3A3A ",
            }}
          >
            19
          </p>
          <p
            className="mb-0"
            style={{ fontSize: "14px", fontWeight: "500", color: "#75738C" }}
          >
            Total Number of Carriers
          </p>
        </div>
      </div>
      <div
        style={{
          width: "25%",
          border: "none",
          borderRadius: "6px 0px 0px 6px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "20px",
          gap: "20px",
          borderRight: ".6px solid  #D6D6D6",
        }}
      >
        <img src={img2} style={{ height: "47px", width: "47px" }}></img>
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <p
            className="mb-0"
            style={{
              fontSize: "20px ",
              fontWeight: "700 ",
              color: "#3B3A3A ",
            }}
          >
            250
          </p>
          <p
            className="mb-0"
            style={{ fontSize: "14px", fontWeight: "500", color: "#75738C" }}
          >
            Total Networks
          </p>
        </div>
      </div>{" "}
      <div
        style={{
          width: "25%",
          border: "none",
          borderRadius: "6px 0px 0px 6px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "20px",
          gap: "20px",
        }}
      >
        <img src={img3} style={{ height: "47px", width: "47px" }}></img>
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <p
            className="mb-0"
            style={{
              fontSize: "20px ",
              fontWeight: "700 ",
              color: "#3B3A3A ",
            }}
          >
            607K
          </p>
          <p
            className="mb-0"
            style={{ fontSize: "14px", fontWeight: "500", color: "#75738C" }}
          >
            Billing NPI Count
          </p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
